/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Banner,
  Button,
  ButtonGroup,
  Icon,
  Link,
  ActionList,
  Popover,
  TextStyle
} from '@shopify/polaris';
import {
  ChevronUpMinor,
  ChevronDownMinor,
  ExternalMinor,
  HorizontalDotsMinor,
  ProfileMinor,
  CancelSmallMinor
} from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import classNames from 'classnames';

import history from 'src/routes/history';
import { routes } from 'src/routes';
import { getShop } from 'src/helpers';
import { URL } from 'src/constants/links';
import { enableShopifyIntegration } from 'src/helpers/theme-setup-helper';
import { APP_VERSION_OLD_VERSION, APP_VERSION_TURBO } from 'src/constants/accounts';
import V3ToTurboDashboard from 'assets/images/dashboard-v3/v3-to-turbo-dashboard.png';
import TurboThemeSetup from 'assets/images/dashboard-v3/v3-to-turbo-theme-setup.png';
import TurboDashboard from 'assets/images/dashboard-v3/turbo-dashboard.png';
import TurboSI from 'assets/images/dashboard-v3/turbo-si.png';
import Rocket from 'src/assets/images/common/rocket.svg';
import Ledger from 'src/assets/images/common/ledger.svg';
import { isInWhiteListTurboV2 } from 'src/helpers/whitelist';

type State = {};
export const KEY_BOOST_TURBO_BANNER_DASHBOARD = 'already-close-banner-boost-turbo-dashboard';
export const KEY_BOOST_TURBO_BANNER_SI = 'already-close-banner-boost-turbo-si';

export const KEY_TO_TURBO_BANNER_DASHBOARD = 'already-close-banner-to-turbo-dashboard';
export const KEY_TO_TURBO_BANNER_THEME_SETUP = 'already-close-banner-to-turbo-theme-setup';

class BannerUpgradeTurbo extends Component<WithI18nProps, State> {
  state = {
    showBanner: true,
    activeAction: false,
    isCollapsed: false
  };

  getCurrentVersion = () => {
    const { tenantApp } = this.props;

    const { appVersion } = tenantApp;
    const isEnableShopifyIntegration = enableShopifyIntegration(tenantApp);
    const initAppVersion = appVersion
      ? appVersion
      : isEnableShopifyIntegration
      ? APP_VERSION_TURBO
      : APP_VERSION_OLD_VERSION;
    return initAppVersion;
  };

  handleToAppPreference = () => {
    history.push(routes.appPreferences.view());
  };

  handleHowToSetupTurbo = () => {
    window.open(URL['SetupWidgetForTheme'], '_blank');
  };

  handleToTurboLandingPage = () => {
    history.push(routes.landing.turbo());
  };

  handleDismiss = () => {
    const { tenantApp, isDashboard } = this.props;
    const initAppVersion = this.getCurrentVersion();
    const isEnableShopifyIntegration = enableShopifyIntegration(tenantApp);

    try {
      if (isDashboard) {
        if (initAppVersion === APP_VERSION_TURBO) {
          localStorage.setItem(`${getShop()}-${KEY_BOOST_TURBO_BANNER_DASHBOARD}`, true);
        } else {
          localStorage.setItem(`${getShop()}-${KEY_TO_TURBO_BANNER_DASHBOARD}`, true);
        }
      } else {
        if (isEnableShopifyIntegration) {
          localStorage.setItem(`${getShop()}-${KEY_BOOST_TURBO_BANNER_SI}`, true);
        } else {
          localStorage.setItem(`${getShop()}-${KEY_TO_TURBO_BANNER_THEME_SETUP}`, true);
        }
      }
      this.setState({
        showBanner: false
      });
    } catch (error) {
      console.log('error', error);
    }
  };

  toggleCollapse = () => {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    });
  };

  togglePopover = () => {
    this.setState({
      activeAction: !this.state.activeAction
    });
  };

  renderBannerFormer = () => {
    const { isCollapsed } = this.state;
    const { i18n, isDashboard, tenantApp } = this.props;

    return (
      <Banner status="warning">
        <div
          className="banner-info turbo-banner turbo-banner--orange"
          id={isDashboard ? 'banner-former-dashboard' : 'banner-former'}>
          <h2 className="title">
            <img src={Rocket} alt="rocket" />
            {i18n.translate('AdminHTML.DashboardV3.TurboBanner.title')}
          </h2>
          {!isCollapsed && (
            <ul className="banner-info-list">
              {isInWhiteListTurboV2(tenantApp.tenantId) ? (
                <>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.TurboBannerV2.description1', {
                      t: (
                        <b>
                          {i18n.translate('AdminHTML.DashboardV3.TurboBannerV2.description1_t')}
                        </b>
                      )
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.TurboBannerV2.description2', {
                      t: (
                        <b>
                          {i18n.translate('AdminHTML.DashboardV3.TurboBannerV2.description2_t')}
                        </b>
                      )
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.TurboBannerV2.description3', {
                      t: (
                        <b>
                          {i18n.translate('AdminHTML.DashboardV3.TurboBannerV2.description3_t')}
                        </b>
                      )
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.TurboBannerV2.description4', {
                      t: (
                        <b>
                          {i18n.translate('AdminHTML.DashboardV3.TurboBannerV2.description4_t')}
                        </b>
                      )
                    })}
                  </li>
                </>
              ) : (
                <>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.TurboBanner.description1', {
                      t: <b>{i18n.translate('AdminHTML.DashboardV3.TurboBanner.description1_t')}</b>
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.TurboBanner.description2', {
                      t: <b>{i18n.translate('AdminHTML.DashboardV3.TurboBanner.description2_t')}</b>
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.TurboBanner.description3', {
                      t: <b>{i18n.translate('AdminHTML.DashboardV3.TurboBanner.description3_t')}</b>
                    })}
                  </li>
                </>
              )}
            </ul>
          )}

          <div
            className={classNames('banner-info-cta', {
              'banner-info-cta--collapsed': isCollapsed
            })}>
            <ButtonGroup>
              <Button onClick={this.handleToAppPreference}>
                {i18n.translate('AdminHTML.DashboardV3.TurboBanner.btnUpgrade')}
              </Button>
              <Button onClick={this.handleToTurboLandingPage} external>
                {i18n.translate('AdminHTML.AppPreferences.TurboBanner.btnSeeWhatNew')}
              </Button>
            </ButtonGroup>
          </div>

          <div className="banner-action">
            <Popover
              active={this.state.activeAction}
              activator={<Button icon={HorizontalDotsMinor} plain onClick={this.togglePopover} />}
              onClose={this.togglePopover}
              preferredAlignment="right">
              <ActionList
                items={[
                  {
                    content: i18n.translate('AdminHTML.Common.Action.dismiss'),
                    onAction: this.handleDismiss
                  }
                ]}
              />
            </Popover>

            <Button onClick={this.toggleCollapse} plain>
              <Icon source={isCollapsed ? ChevronDownMinor : ChevronUpMinor} />
            </Button>
          </div>
          <div className="banner-extra actions">
            <Link url={URL['HowToUpgradeTurbo']} external>
              {i18n.translate('AdminHTML.AppPreferences.TurboBanner.howToUpgrade')}
              <Icon source={ExternalMinor} />
            </Link>
          </div>

          {!isCollapsed && (
            <img
              className="turbo-img"
              src={isDashboard ? V3ToTurboDashboard : TurboThemeSetup}
              alt="turbo"
            />
          )}
        </div>
      </Banner>
    );
  };

  renderBannerTurboDashboard = () => {
    const { isCollapsed } = this.state;
    const { i18n, tenantApp } = this.props;

    return (
      <Banner status="info">
        <div className="banner-info turbo-banner" id="banner-turbo-dashboard">
          <h2 className="title">
            <img src={Rocket} alt="rocket" />
            {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBanner.title')}
          </h2>
          {!isCollapsed && (
            <ul className="banner-info-list">
              {isInWhiteListTurboV2(tenantApp.tenantId) ? (
                <>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBannerV2.description1', {
                      t: (
                        <b>
                          {i18n.translate(
                            'AdminHTML.DashboardV3.WelcomeTurboBannerV2.description1_t'
                          )}
                        </b>
                      )
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBannerV2.description2', {
                      t: (
                        <b>
                          {i18n.translate(
                            'AdminHTML.DashboardV3.WelcomeTurboBannerV2.description2_t'
                          )}
                        </b>
                      )
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBannerV2.description3', {
                      t: (
                        <b>
                          {i18n.translate(
                            'AdminHTML.DashboardV3.WelcomeTurboBannerV2.description3_t'
                          )}
                        </b>
                      )
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBannerV2.description4', {
                      t: (
                        <b>
                          {i18n.translate(
                            'AdminHTML.DashboardV3.WelcomeTurboBannerV2.description4_t'
                          )}
                        </b>
                      )
                    })}
                  </li>
                </>
              ) : (
                <>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBanner.description1', {
                      t: (
                        <b>
                          {i18n.translate(
                            'AdminHTML.DashboardV3.WelcomeTurboBanner.description1_t'
                          )}
                        </b>
                      )
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBanner.description2', {
                      t: (
                        <b>
                          {i18n.translate(
                            'AdminHTML.DashboardV3.WelcomeTurboBanner.description2_t'
                          )}
                        </b>
                      )
                    })}
                  </li>
                  <li>
                    {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBanner.description3', {
                      t: (
                        <b>
                          {i18n.translate(
                            'AdminHTML.DashboardV3.WelcomeTurboBanner.description3_t'
                          )}
                        </b>
                      )
                    })}
                  </li>
                </>
              )}
            </ul>
          )}

          {!isCollapsed && (
            <div className="banner-info-manage">
              <p>
                {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBanner.manageVersion', {
                  t: (
                    <span>
                      <Icon source={ProfileMinor} />
                      {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBanner.manageVersion_t')}
                    </span>
                  )
                })}
              </p>
            </div>
          )}

          <div
            className={classNames('actions banner-info-cta banner-info-cta--outline', {
              'banner-info-cta--collapsed': isCollapsed
            })}>
            <ButtonGroup>
              <Button onClick={this.handleHowToSetupTurbo}>
                {i18n.translate('AdminHTML.DashboardV3.WelcomeTurboBanner.btnPublish')}
              </Button>
              <Button onClick={this.handleToTurboLandingPage} external plain>
                <span>{i18n.translate('AdminHTML.AppPreferences.TurboBanner.btnSeeWhatNew')}</span>
                <Icon source={ExternalMinor} />
              </Button>
            </ButtonGroup>
          </div>

          <div className="banner-action">
            <Button onClick={this.toggleCollapse} plain>
              <Icon source={isCollapsed ? ChevronDownMinor : ChevronUpMinor} />
            </Button>
          </div>

          <div className="banner-extra">
            <Button plain onClick={this.handleDismiss}>
              <TextStyle variation="subdued">
                {i18n.translate('AdminHTML.Common.Action.dismiss')}
              </TextStyle>
            </Button>
          </div>

          {!isCollapsed && <img className="turbo-img" src={TurboDashboard} alt="turbo" />}
        </div>
      </Banner>
    );
  };

  renderBannerTurboShopifyIntegration = () => {
    const { isCollapsed } = this.state;
    const { i18n } = this.props;

    return (
      <Banner status="info">
        <div
          className="banner-info turbo-banner"
          style={{ paddingTop: '31px', paddingBottom: '31px' }}
          id="banner-turbo-si">
          <h2 className="title title--smaller">
            <img src={Ledger} alt="ledger" />
            {i18n.translate('AdminHTML.DashboardV3.TurboBannerSI.title')}
          </h2>
          {!isCollapsed && (
            <ul className="banner-info-list" style={{ marginBottom: 0 }}>
              <li>{i18n.translate('AdminHTML.DashboardV3.TurboBannerSI.description1')}</li>
              <li>{i18n.translate('AdminHTML.DashboardV3.TurboBannerSI.description2')}</li>
            </ul>
          )}
          <div
            className={classNames('actions banner-info-cta banner-info-cta--outline', {
              'banner-info-cta--collapsed': isCollapsed
            })}>
            <ButtonGroup>
              <Button onClick={this.handleHowToSetupTurbo}>
                {i18n.translate('AdminHTML.AppPreferences.TurboBanner.btnHowToSetup')}
              </Button>
              <Button onClick={this.handleToTurboLandingPage} external plain>
                <span>{i18n.translate('AdminHTML.AppPreferences.TurboBanner.btnSeeWhatNew')}</span>
                <Icon source={ExternalMinor} />
              </Button>
            </ButtonGroup>
          </div>

          <div className="banner-action">
            <Button onClick={this.handleDismiss} plain>
              <Icon source={CancelSmallMinor} />
            </Button>
          </div>

          {!isCollapsed && <img className="turbo-img turbo-img--si" src={TurboSI} alt="turbo" />}
        </div>
      </Banner>
    );
  };

  render() {
    const { isDashboard } = this.props;
    const { showBanner } = this.state;
    const initAppVersion = this.getCurrentVersion();

    if (!showBanner) {
      return null;
    }

    return (
      <div
        className={classNames('BC-UpgradeTurbo__Dashboard', {
          'BC-UpgradeTurbo__Dashboard--turbo': initAppVersion === APP_VERSION_TURBO
        })}>
        {initAppVersion === APP_VERSION_OLD_VERSION && this.renderBannerFormer()}
        {initAppVersion === APP_VERSION_TURBO && isDashboard && this.renderBannerTurboDashboard()}
        {initAppVersion === APP_VERSION_TURBO &&
          !isDashboard &&
          this.renderBannerTurboShopifyIntegration()}
      </div>
    );
  }

  toggleModal = (fieldName, fromThemeFailed = false) => {
    if (fromThemeFailed) this.setState({ requestModalThemeFailed: true });
    else this.setState({ requestModalThemeFailed: false });

    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };

  handleCollapsed = () => {
    this.setState({
      isCollapsed: true
    });
  };
}

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});

  return {
    tenantApp
  };
};

export default withI18n()(connect(mapStateToProps)(BannerUpgradeTurbo));
